"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = _interopRequireDefault(require("./styles"));
var _notistack = require("notistack");
var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));
var _Input = _interopRequireDefault(require("@material-ui/core/Input"));
var _ContentCopy = _interopRequireDefault(require("mdi-material-ui/ContentCopy"));
var _reactShare = require("react-share");
var _useTheme = _interopRequireDefault(require("@material-ui/core/styles/useTheme"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ShareButtonGroup = props => {
  var classes = (0, _styles.default)(props);
  var theme = (0, _useTheme.default)();
  var {
    size,
    shareLink,
    postTitle,
    position = 'right',
    excludeEmail = true,
    excludeCopyToClipboard = true
  } = props;
  var {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();

  // Create ref to hidden textfield so we can transmit share link to user's clipboard.
  var hiddenTextAreaRef = _react.default.useRef(null);
  var contentSize = size === 'small' ? 32 : 50;

  /**
   * Adpated from:
   * https://stackoverflow.com/questions/39501189/in-reactjs-how-to-copy-text-to-clipboard
   * @Nate
   */
  var onCopyToClipboard = e => {
    hiddenTextAreaRef.current.select();
    document.execCommand('copy');
    e.target.focus();
    onShareFinished('Link copied to clipboard');
  };
  var onShareFinished = msg => {
    enqueueSnackbar(msg, {
      variant: 'info',
      preventDuplicate: true
    });
  };
  var className = [classes.socialGroup];
  position === 'left' ? className.push(classes.left) : className.push(classes.right);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.socialGroup
  }, /*#__PURE__*/_react.default.createElement(_reactShare.FacebookShareButton, {
    url: shareLink,
    className: classes.shareButton
  }, /*#__PURE__*/_react.default.createElement(_reactShare.FacebookIcon, {
    size: contentSize
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.leftSpaced
  }, /*#__PURE__*/_react.default.createElement(_reactShare.TwitterShareButton, {
    url: shareLink,
    className: classes.shareButton
  }, /*#__PURE__*/_react.default.createElement(_reactShare.TwitterIcon, {
    size: contentSize
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.leftSpaced
  }, /*#__PURE__*/_react.default.createElement(_reactShare.RedditShareButton, {
    url: shareLink,
    className: classes.shareButton
  }, /*#__PURE__*/_react.default.createElement(_reactShare.RedditIcon, {
    size: contentSize,
    bgStyle: {
      fill: theme.palette.brands.reddit_orange
    }
  }))), !excludeEmail && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.leftSpaced
  }, /*#__PURE__*/_react.default.createElement(_reactShare.EmailShareButton, {
    subject: "Checkout this post on ELEVATOR: \"".concat(postTitle, "\""),
    url: shareLink,
    className: classes.shareButton
  }, /*#__PURE__*/_react.default.createElement(_reactShare.EmailIcon, {
    size: contentSize
  }))), !excludeCopyToClipboard && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.leftSpaced, classes.contentCopyButtonContainer)
  }, /*#__PURE__*/_react.default.createElement(_ButtonBase.default, {
    onClick: onCopyToClipboard
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.contentCopyButton, size === 'small' ? classes.smallButton : classes.largeButton)
  }, /*#__PURE__*/_react.default.createElement(_ContentCopy.default, {
    fontSize: 'small'
  }))), /*#__PURE__*/_react.default.createElement("div", {
    id: 'link-share-target',
    className: classes.hiddenInput
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    readOnly: true,
    inputRef: hiddenTextAreaRef,
    value: shareLink
  }))));
};
var _default = exports.default = ShareButtonGroup;